type WithName = { name: string };

export const sortByName = <T extends WithName>(items: T[]): T[] =>
  [...items].sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
